import { filterTagsBySearchText } from '@griply/utils';
import { useTags } from 'features/tags/hooks/use-tags';
import { useMemo } from 'react';

export const useTextFilteredTags = (searchText: string) => {
  const tags = useTags();

  return useMemo(
    () => filterTagsBySearchText(tags, searchText),
    [searchText, tags],
  );
};
